(function () {
    'use strict';

    function initializeDesktopMenu() {
        var shell = document.querySelector('[data-desktop-menu]');
        if (!shell) {
            return;
        }

        var navigation = shell.querySelector('#AccessibleNav');
        var list = shell.querySelector('#siteNav');
        var button = shell.querySelector('.desktop-menu-more');
        var label = button.querySelector('[data-menu-more-label]');
        var items = Array.prototype.slice.call(list.children);
        var desktop = window.matchMedia('(min-width: 992px)');
        var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var expanded = false;
        var resizeFrame = null;

        function closeMegamenus() {
            items.forEach(function (item) {
                if (!item.classList.contains('is-open')) {
                    return;
                }

                item.classList.remove('is-open');
                var toggle = item.querySelector('.js-megamenu-toggle');
                if (toggle) {
                    toggle.setAttribute('aria-expanded', 'false');
                }
            });
        }

        function showItems() {
            items.forEach(function (item) {
                item.hidden = false;
            });
        }

        function setExpanded(value) {
            expanded = value;
            shell.classList.toggle('is-expanded', value);
            button.setAttribute('aria-expanded', String(value));
            label.textContent = button.getAttribute(value ? 'data-label-less' : 'data-label-more');
        }

        function collapseMenu() {
            closeMegamenus();
            showItems();
            setExpanded(false);
            button.hidden = true;
            navigation.scrollLeft = 0;

            if (!desktop.matches || !shell.clientWidth) {
                return;
            }

            var widths = items.map(function (item) {
                var style = window.getComputedStyle(item);
                return item.getBoundingClientRect().width + parseFloat(style.marginLeft) + parseFloat(style.marginRight);
            });
            var totalWidth = widths.reduce(function (total, width) {
                return total + width;
            }, 0);

            if (totalWidth <= navigation.clientWidth + 1) {
                return;
            }

            button.hidden = false;
            var availableWidth = navigation.clientWidth;
            var usedWidth = 0;
            var overflow = false;

            items.forEach(function (item, index) {
                usedWidth += widths[index];
                overflow = overflow || usedWidth > availableWidth + 1;
                item.hidden = overflow;
            });
        }

        button.addEventListener('click', function () {
            if (expanded) {
                collapseMenu();
                return;
            }

            closeMegamenus();
            showItems();
            setExpanded(true);
            navigation.scrollTo({
                left: navigation.scrollWidth,
                behavior: motion.matches ? 'auto' : 'smooth'
            });
        });

        navigation.addEventListener('scroll', closeMegamenus, { passive: true });
        window.addEventListener('resize', function () {
            window.cancelAnimationFrame(resizeFrame);
            resizeFrame = window.requestAnimationFrame(collapseMenu);
        });
        window.addEventListener('load', collapseMenu);
        if (document.fonts) {
            document.fonts.ready.then(collapseMenu);
        }
        collapseMenu();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeDesktopMenu);
    } else {
        initializeDesktopMenu();
    }
}());
